module.exports = __webpack_public_path__ + "Flag-581.745b89a14ecb57af4ccaa368364f6c91.svg";